import PropTypes from "prop-types"

const TitleWithDivider = ({ children }) => {
  return (
    <div className="border-t-grey-20 my-32 border-t">
      <h2 className="text-18 tablet:text-24 tablet:9/20 -tablet:mt-18 mx-auto -mt-14 w-3/5 bg-white text-center font-normal">
        {children}
      </h2>
    </div>
  )
}

TitleWithDivider.propTypes = {
  children: PropTypes.node,
}

export default TitleWithDivider
